export default "__VITE_ASSET__BZPjnHaz__"